// extracted by mini-css-extract-plugin
export default {"error":"style_error__0b4Fl","wrapper":"style_wrapper__jmcqv","content":"style_content__Eq-+V","text":"style_text__jLuV5","img":"style_img__B48j0"};